import request from '@/utils/request'
import qs from 'qs'
// 商品管理
// 分页查询
export function getImgTil(params) {
  return request({
    url: `/mall/stockmanage/mallstorestock/queryMallStoreStock/${params}`,
    method: 'POST'
  })
}
// 收藏商品
export function CollectionData(mallstoreStockId, mallstoreId, operationType) {
  return request({
    url: `/mall/stockmanage/mallstorestock/collectStock/${mallstoreStockId}/${mallstoreId}/${operationType}`,
    method: 'GET'
  })
}
// 店铺推荐
export function shopRecommend(mallstoreStockId, FSearchType) {
  return request({
    url: `/mall/stockmanage/mallstorestock/mallstoreRecommend/${mallstoreStockId}?FSearchType=${FSearchType}`,
    method: 'GET'
  })
}
// 选项获取数据
export function getShopTable(data) {
  return request({
    url: '/mall/stockmanage/mallstorestock/querySameSeriesStock',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 商品介绍
export function getShopIntroduce(params) {
  return request({
    url: `/mall/stockmanage/mallstorestock/stocktIntroduce/${params}`,
    method: 'POST'
  })
}
// 评价
export function getcomment(params) {
  return request({
    url: `/mall/stockmanage/mallstorestock/appraiseHeader/${params}`,
    method: 'POST'
  })
}
// 评价表格数据
export function getcommentTable(params) {
  return request({
    url: '/mall/stockmanage/mallstorestock/queryAppraisePage',
    method: 'POST',
    params
  })
}
// 规格参数
export function getparameter(params, FSearchType) {
  return request({
    url: `/mall/stockmanage/mallstorestock/queryStdStockProp/${params}?FSearchType=${FSearchType}`,
    method: 'GET'
  })
}
// 加入购物车
export function addTocart(data) {
  return request({
    url: 'mall/stockmanage/mallstorestock/addShoppingCart',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 立即购买
export function getByNow(data) {
  return request({
    url: 'mall/mallmanage/demandOrder/settlementShoppingCart',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 提交订单
export function gosShaopOrder(data) {
  return request({
    url: 'mall/mallmanage/demandOrder/submitOrder',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 确认交易
export function confirmTransaction(data) {
  return request({
    url: '/mall/mallmanage/demandOrder/confirmOrder',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function shopUserPho(params) {
  return request({
    url: '/mall/demandstock/queryProviderMallStoreLink',
    method: 'POST',
    params
  })
}
